import { AddJobStep1Details } from "../../types/addJobStep1Details";
import { JobPendingStepOneResponse } from "../controllers/jobs";

export const convertAddJobStep1DetailsResponse = (
    response: JobPendingStepOneResponse,
    hasActiveTeamPlan: boolean
): AddJobStep1Details => {
    if (!response) return null;

    const step1Details = new AddJobStep1Details();
    step1Details.teamId = response.teamId;
    step1Details.attachment = response.attachment;
    step1Details.externalDescription = response.externalDescription;
    step1Details.isIntegrated = response.isIntegrated;
    step1Details.hasActiveTeamPlan = hasActiveTeamPlan;
    step1Details.jobConcurrencyToken = response.jobConcurrencyToken;

    return step1Details;
};
